<template>
  <div>
    <div class="page-wrap">
      <h2 class="title-page fw-500">
        <i class="fas fa-book mr-2"></i>รายการตกค้างรอยืนยัน
      </h2>
      <div class="body-content">
        <p class="mt-3">ค้นหารายการตกค้างรอยืนยัน</p>
        <div class="row">
          <div class="col-md-4">
            <date-picker
              class="input-date w-100"
              valueType="format"
              type="date"
              lang="en"
              v-model="payload.date"
              v-on:change="onchange"
            ></date-picker>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <select
                class="browser-default custom-select input-data input-default"
                name="selectbank"
                v-on:change="onchangeSelectbank($event)"
              >
                <option disabled value="null" selected>
                  เลือกบัญชี
                </option>
                <option
                  v-for="(data, key) in selectbank"
                  :key="key"
                  :value="data.value"
                >
                  {{ data.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="table-content">
          <mdb-datatable
            :arrows="true"
            :data="tableData"
            striped
            bordered
            :searching="false"
            scrollY
            maxHeight="450px"
            v-if="reloading"
          />
        </div>
        <div class="modal-wrapper">
          <mdb-container>
            <mdb-modal
              :show="showModal"
              @close="showModal = false"
              scrollable
              centered
            >
              <mdb-modal-header>
                <mdb-modal-title>
                  <mdb-icon icon="fingerprint" />
                  ย้ายรายการยอดตกค้าง</mdb-modal-title
                >
              </mdb-modal-header>
              <mdb-modal-body>
                <div class="row">
                  <div class="col-12 text-center my-4" v-if="showModaldata">
                    <div class="row mt-2">
                      <div class="col-4 align-self-center">ตกค้างจาก</div>
                      <div class="col-8 pl-0">
                        <input
                          type="text"
                          id="pro_price"
                          disabled
                          :value="
                            showModaldata.acc_bank_code +
                              '/' +
                              showModaldata.acc_bank_number
                          "
                          class="form-control form-control-sm"
                          width="100%"
                        />
                      </div>
                    </div>
                    <div class="row justify-content-center mt-2">
                      <div class="col-4 align-self-center">วันเวลา</div>
                      <div class="col-8 pl-0">
                        <input
                          type="text"
                          id="pro_price"
                          disabled
                          :value="showModaldata.datetime"
                          class="form-control form-control-sm"
                          width="100%"
                        />
                      </div>
                    </div>
                    <div class="row justify-content-center mt-2">
                      <div class="col-4 align-self-center">โอนจากธนาคาร</div>
                      <div class="col-8 pl-0">
                        <input
                          type="text"
                          id="pro_price"
                          disabled
                          :value="showModaldata.bank_code"
                          class="form-control form-control-sm"
                          width="100%"
                        />
                      </div>
                    </div>
                    <div class="row justify-content-center mt-2">
                      <div class="col-4 align-self-center">เลขที่บัญชี</div>
                      <div class="col-8 pl-0">
                        <input
                          type="text"
                          id="pro_price"
                          disabled
                          :value="showModaldata.bank_number"
                          class="form-control form-control-sm"
                          width="100%"
                        />
                      </div>
                    </div>
                    <div class="row justify-content-center mt-2">
                      <div class="col-4 align-self-center">ยอดฝาก</div>
                      <div class="col-8 pl-0">
                        <input
                          type="text"
                          id="pro_price"
                          disabled
                          :value="showModaldata.deposit"
                          class="form-control form-control-sm"
                          width="100%"
                        />
                      </div>
                    </div>
                    <div class="row justify-content-center mt-2 mb-3">
                      <div class="col-4 align-self-center">Username</div>
                      <div class="col-8 pl-0">
                        <input
                          type="text"
                          v-model="username"
                          class="form-control form-control-sm"
                          width="100%"
                        />
                      </div>
                    </div>
                    <button
                      type="button"
                      class="btn btn-search color_white mr-3 font12"
                      style="font-weight:400;"
                      @click="editRemain()"
                    >
                      บันทึก
                    </button>
                    <button
                      type="button"
                      class="btn btn-cancel color_white font12"
                      style="font-weight:400;"
                      @click="editremaincancle()"
                    >
                      ยกเลิก
                    </button>
                  </div>
                </div>
              </mdb-modal-body>
            </mdb-modal>
          </mdb-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
var axios = require("axios");
import DatePicker from "vue2-datepicker";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import jwt from "jsonwebtoken";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      loading: false,
      reloading: false,
      showModal: false,
      selectbank: [],
      idedituser: 0,
      username: null,
      payload: {
        date: moment().format("YYYY-MM-DD"),
        bank_number: "",
      },
      tableData: {
        columns: [
          {
            label: "#",
            field: "id2",
            sort: true,
          },
          {
            label: "วันที่",
            field: "datetime",
            sort: true,
          },
          {
            label: "ยอดฝาก",
            field: "deposit",
            sort: true,
          },
          {
            label: "ธนาคาร",
            field: "bank_code",
            sort: true,
          },
          {
            label: "เลขที่บัญชี",
            field: "bank_number",
            sort: true,
          },
          {
            label: "ตกค้างจาก",
            field: "acc_bank_full",
            sort: true,
          },
          {
            label: "comment",
            field: "comment",
            sort: true,
          },
          {
            label: "จัดการ",
            field: "id",
            sort: true,
            format: (value) => {
              if (value) {
                return (
                  '<div class="text-center btnbtn classclick" style="max-width:110px;" dataid="' +
                  value +
                  '"><label class="bg-file-search text-white font14" style="cursor: pointer;" ><mdb-icon far icon="file-alt" /><i class="fas fa-file-alt fa-13"></i></label></div>'
                );
              }
            },
          },
        ],
        rows: null,
      },
      dataremain: null,
      showModaldata: null,
    };
  },
  computed: {
    ...mapGetters({
      isLogin: "isLogin",
      user: "user",
      tokens: "tokens",
    }),
    data() {
      return {
        columns: [],
        rows: [],
      };
    },
  },
  async mounted() {
    this.reloading = true;
    await this.getBankList();
    await this.getStatementByBank();
    //let edit_detial = this;
  },

  methods: {
    ...mapActions({
      storeLogin: "login",
      storeLoout: "logout",
      loadsession: "loadsession",
      callApiMotherFucker: "callApiMotherFucker",
    }),
    filterData(dataArr, keys) {
      let data = dataArr.map((entry) => {
        let filteredEntry = {};
        keys.forEach((key) => {
          if (key in entry) {
            filteredEntry[key] = entry[key];
          }
        });
        return filteredEntry;
      });
      return data;
    },
    async checkValue() {},
    async getBankList() {
      var config = {
        method: "get",
        url: "https://sms-fast.warmlight.online/api/getBankList",
        headers: {
          Authorization: "Bearer " + this.tokens,
        },
        data: "",
      };
      await axios(config)
        .then((response) => {
          this.selectbank = response.data.payload.map((item) => {
            return {
              value: item.bank_number,
              text: `${item.bank_name}(${item.bank_code})`,
            };
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async onchange() {
      this.getStatementByBank();
    },
    onchangeSelectbank(e) {
      this.payload.bank_number = e.target.value;
      this.onchange();
    },
    async getStatementByBank() {
      this.tableData.rows = null;
      const token = jwt.sign(this.payload, this.$keypayload);
      var config = {
        method: "POST",
        url: "https://sms-fast.warmlight.online/api/getStatementRemain",
        headers: {
          Authorization: "Bearer " + this.tokens,
        },
        data: {
          token: token,
          id: this.idedituser,
          username: this.username,
        },
      };
      await axios(config)
        .then((response) => {
          let result = [];
          this.dataremain = response.data.payload;
          if (response.data.payload && response.data.payload.length > 0) {
            for (const dataapi of response.data.payload) {
              let datadata = {
                id: dataapi.id,
                acc_bank_id: dataapi.acc_bank_id,
                acc_bank_name: dataapi.acc_bank_name,
                acc_bank_number: dataapi.acc_bank_number,
                acc_bank_code: dataapi.acc_bank_code,
                acc_bank_full:
                  dataapi.acc_bank_code + "/" + dataapi.acc_bank_number,
                bank_full: dataapi.bank_code + "/" + dataapi.bank_number,
                balance: dataapi.balance,
                bank_code: dataapi.bank_code,
                bank_number: dataapi.bank_number,
                channel: dataapi.channel,
                datetime: dataapi.datetime,
                deposit: dataapi.deposit,
                detail: dataapi.detail,
              };
              result.push(datadata);
            }
          }

          this.tableData.rows = this.$add_index(result);
          this.reloading = false;
          this.$nextTick(() => {
            this.reloading = true;
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.onClickList();
    },
    editRemain() {
      if (this.username == null) {
        this.Notifyalert("กรุณากรอก Username", "warning");
      } else {
        const payload = {
          username: this.username,
          id: this.showModaldata.id,
        };
        const token = jwt.sign(payload, this.$keypayload);
        var config = {
          method: "POST",
          url: "https://sms-fast.warmlight.online/api/remainAddCredit",
          headers: {
            Authorization: "Bearer " + this.tokens,
          },
          data: {
            token: token,
          },
        };
        let context = this;
        axios(config)
          .then(function(response) {
            if (response.data) {
              context.NotifyXXNew(response.data.msg, response.data.code);
            context.showModal = false;
              context.getStatementByBank();
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    editremaincancle() {
      this.showModal = false;
    },

    onClickList() {
      let edit_detial = this;

      $(".classclick").on("click", function() {
        let id = $(this).attr("dataid") || 0;
        edit_detial.idedituser = id; // เอาid มาเก็บไว้ในตัวแปร idedituser เพื่อจะนำไปอัพเดท

        if (id > 0) {
          edit_detial.showModal = true;
          edit_detial.showModaldata = null;
          edit_detial.dataremain.forEach((element) => {
            if (element.id === parseInt(id)) {
              edit_detial.showModaldata = element;
            }
          });
        }
      });
    },
    Notifyalert(message, icon) {
      this.$swal({
        text: message,
        icon: icon,
        timer: 5000,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },
    NotifyXXNew(message, code) {
      let icon = "warning";
      if (code == 0) {
        icon = "success";
      }
      this.$swal({
        text: message,
        icon: icon,
        timer: 5000,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },
  },
};
</script>

<style>
.modal-wrapper .modal-header {
  background: #f5904b;
  color: #fff;
}

.modal-wrapper .modal-header .close {
  color: #fff;
  opacity: 1;
}
</style>
